export default __webpack_public_path__ + "static/media/trafic-medium2.6eb45b80.jpg";